/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-12 11:57:03
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-12 11:57:21
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/Components/index.ts
 */
export { default as ProductList } from './ProductList';
